module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/home/star_sign.png";